// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPractice {
    static getAttributeTypeMap() {
        return MedicalBiPractice.attributeTypeMap;
    }
}
MedicalBiPractice.discriminator = undefined;
MedicalBiPractice.additionalProperties = false;
MedicalBiPractice.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "additionalId",
        "baseName": "additionalId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPractice.js.map